<template>
	<div>
		<div
			class="topic-gicards d-flex"
			@click="topicDetails.active ? goToTest() : ''"
			:class="
				selTopic == topicDetails.topicID
					? 'changecolor'
					: topicDetails.active
					? 'pointer'
					: 'defaultCursor'
			"
		>
			<div
				:class="
					topicDetails.active
						? 'topic-ls-gridgreencolorStatic'
						: 'topic-ls-gridredcolorStatic'
				"
			></div>
			<div class="d-flex flex-column pr-4" style="width: 55%">
				<div v-if="topicDetails.active">
					<div class="topic-gt-tctxt">
						<div
							class="position-relative tp-cardhead d-flex align-items-center ellipsis"
						>
							<span style="margin-bottom: 4px"
								><img src="../../../assets/active.svg" alt="" class="mb-1"
							/></span>

							<div class="text-truncate ml-1">
								<span
									v-b-popover.hover.top="topicDetails.name"
									style="max-width: 100%"
									class="d-inline-block text-truncate"
								>
									{{ topicDetails.name }}
								</span>
							</div>
						</div>
					</div>
					<div
						class="text-truncate tplist-card-content"
						:id="topicDetails.topicID"
					>
						<span
							v-if="topicDetails.description.length > 0"
							v-b-popover.bottom="topicDetails.description"
							style="max-width: 100%"
							class="d-inline-block text-truncate"
						>
							{{ topicDetails.description }}
						</span>

						<div v-else class="d-flex align-items-center justify-content-left">
							<div><img src="../../../assets/nodataicon.svg" alt="" /></div>
							<div class="topicDescBreak">Description not available</div>
						</div>
					</div>
				</div>
				<div v-else>
					<div class="topic-gt-tctxt">
						<div class="tp-cardhead d-flex align-items-center ellipsis">
							<span style="margin-bottom: 4px"
								><img src="../../../assets/inactive.svg" alt="" class="mb-1"
							/></span>

							<div class="text-truncate ml-1">
								<span
									v-b-popover.hover.top="topicDetails.name"
									style="max-width: 100%"
									class="d-inline-block text-truncate"
								>
									{{ topicDetails.name }}
								</span>
							</div>
						</div>
					</div>
					<div
						class="text-truncate tplist-card-content mt-2"
						:id="topicDetails.topicID"
					>
						<span
							v-if="topicDetails.description.length > 0"
							v-b-popover.top="topicDetails.description"
							style="max-width: 100%"
							class="d-inline-block text-truncate"
						>
							{{ topicDetails.description }}
						</span>
						<div v-else class="d-flex align-items-center justify-content-left">
							<div><img src="../../../assets/nodataicon.svg" alt="" /></div>
							<div class="topicDescBreak">Description not available</div>
						</div>
					</div>
				</div>
			</div>
			<div
				class="d-flex flex-column"
				style="width: 10%"
				v-if="topicDetails.active"
			>
				<div class="topic-gt-tctxt">Tests</div>
				<div style="width: 10%" v-b-popover.hover.top="'No. of Tests taken'">
					<span v-if="topicDetails.testCount < 10" class="greennumbertext"
						>0{{ topicDetails.testCount }}</span
					>
					<span v-else class="greennumbertext">{{
						topicDetails.testCount
					}}</span>
				</div>
			</div>
			<div class="d-flex flex-column" style="width: 10%" v-else>
				<div class="topic-gt-tctxt">Tests</div>
				<div style="width: 10%" v-b-popover.hover.top="'No. of Tests taken'">
					<span
						v-if="topicDetails.inActiveTestCount < 10"
						class="greennumbertext"
						>0{{ topicDetails.inActiveTestCount }}</span
					>
					<span v-else class="greennumbertext">{{
						topicDetails.inActiveTestCount
					}}</span>
				</div>
			</div>

			<div
				class="d-flex flex-column"
				style="width: 10%"
				v-if="topicDetails.active"
			>
				<div class="topic-gt-tctxt">Candidates</div>
				<div
					style="width: 10%"
					v-b-popover.hover.top="'No. of Candidates taken test'"
				>
					<span v-if="topicDetails.candidateCount < 10" class="yellownumbertext"
						>0{{ topicDetails.candidateCount }}</span
					>
					<span v-else class="yellownumbertext">{{
						topicDetails.candidateCount
					}}</span>
				</div>
			</div>
			<div class="d-flex flex-column" style="width: 10%" v-else>
				<div class="topic-gt-tctxt">Candidates</div>
				<div
					style="width: 10%"
					v-b-popover.hover.top="'No. of Candidates taken test'"
				>
					<span v-if="topicDetails.candidateCount < 10" class="yellownumbertext"
						>0{{ topicDetails.candidateCount }}</span
					>
					<span v-else class="yellownumbertext">{{
						topicDetails.candidateCount
					}}</span>
				</div>
			</div>

			<div
				class="d-flex align-items-center justify-content-center"
				style="width: 15%"
			>
				<div
					class="active-btn d-flex align-items-center justify-content-center"
					v-if="topicDetails.active"
				>
					<div class="active-text">Active</div>
				</div>
				<div
					class="inactive-btn d-flex align-items-center justify-content-center"
					v-else
				>
					<div class="inactive-text">Inactive</div>
				</div>
			</div>
			<div
				class="d-flex align-items-center justify-content-end"
				style="width: 10%"
				v-if="!topicDetails.active"
			>
				<img
					v-if="roles.includes('ACTIVATE_TOPIC')"
					@click.stop="copyingVal()"
					v-b-popover.hover.top="'Activate'"
					src="../../../assets/Active (2).svg"
					alt=""
					:class="{ pointer: !topicDetails.active }"
				/>
			</div>

			<div
				class="d-flex align-items-center justify-content-end"
				v-if="topicDetails.active"
				style="width: 10%"
			>
				<div>
					<div
						@click.stop
						class="d-flex align-items-center"
						v-if="!topicDetails.editoption"
					>
						<img
							v-if="
								roles.includes('PUT_TOPIC') || roles.includes('DELETE_TOPIC')
							"
							v-b-popover.hover.top="'View More'"
							src="../../../assets/dots (1).svg"
							alt=""
							@click.stop="$emit('card-option', topicDetails.topicID, true)"
						/>
					</div>

					<div
						class="d-flex"
						v-if="topicDetails.editoption"
						style="border-radius: 55px; border: 0.5px solid #dbdbdb"
					>
						<img
							v-if="roles.includes('PUT_TOPIC')"
							v-b-popover.hover.top="'Edit'"
							@click.stop="copyingVal()"
							src="../../../assets/pencilicon.svg"
							alt=""
							class="m-1"
						/>
						<img
							v-if="roles.includes('DELETE_TOPIC')"
							v-b-popover.hover.top="'Delete'"
							@click.stop="
								(deleteModal = !deleteModal), (selTopic = topicDetails.topicID)
							"
							src="../../../assets/deleteicon.svg"
							alt=""
							class="m-1"
						/>

						<img
							src="../../../assets/closeicon.svg"
							v-b-popover.hover.top="'Close'"
							alt=""
							class="m-1"
							@click.stop="$emit('card-option', null, true)"
						/>
					</div>
				</div>
			</div>
		</div>

		<ActivateTopicModal
			:theTopicName="theTopicName"
			:totalTestCount="totalTestCount"
			:totalTestArr="totalTestArr"
			:actualres="actualres"
			:context="this"
		/>

		<EditTopicModal
			:topicDetails="topicDetails"
			:nameEdit="nameEdit"
			:clone="clone"
			:context="this"
		/>
		<!-- Edit PopUp Ends   -->

		<!-----------------  Delete Popup starts -------->
		<DeleteTopicModal :clone="clone" :context="this" />
		<!-----------------  Delete Popup ends -------->

		<!-- Modals Ends -->
	</div>
</template>

<script>
import { required, maxLength } from "vuelidate/lib/validators";
import { mapGetters } from "vuex";
import toast from "../../mixin/toast.js";
import { copyingVal, goToTest } from "@/controllers/topics/helpers";

import EditTopicModal from "@/controllers/topics/Modals/EditModal.vue";
import DeleteTopicModal from "@/controllers/topics/Modals/DeleteModal.vue";
import ActivateTopicModal from "@/controllers/topics/Modals/ActivateModal.vue";

export default {
	name: "TopicCardGrid",
	mixins: [toast],
	data() {
		return {
			nameEdit: "",
			selTopic: "",
			sortColumn: "createdAt",
			count: "all",
			totalTestCount: 0,
			sortorder: -1,
			page: 0,
			LoaderStatus: false,
			theTopicName: "",
			isActive: false,
			design: false,
			editoptions: false,
			active: true,
			topicModal: false,
			deleteModal: false,
			allTestIds: [],
			totalTestArr: [],
			actualres: {},
			clone: { ...this.topicDetails },
			options: [
				{ item: true, name: "Yes" },
				{ item: false, name: "No" },
			],
		};
	},
	props: {
		showindex: Number,
		topicDetails: Object,
		simp: Boolean,
		type: String,
		sort: String,
	},
	components: {
		EditTopicModal,
		DeleteTopicModal,
		ActivateTopicModal,
	},
	validations: {
		clone: {
			name: {
				required,
				maxLength: maxLength(128),
			},
			description: {
				maxLength: maxLength(512),
			},
		},
	},
	computed: {
		...mapGetters(["roles"]),
	},
	methods: {
		copyingVal() {
			copyingVal(this);
		},
		goToTest() {
			goToTest(this);
		},
	},
};
</script>

<style>
.changecolor {
	background: #ebf5fe;
	border: 2px solid #84bae7;
	border-radius: 5px;
	padding: 15px;
	width: 100%;
}
.slide-fade-leave-active {
	transition: all 0.3s ease;
}

.slide-fade-enter,
.slide-fade-leave-to

/* .slide-fade-leave-active below version 2.1.8 */ {
	transform: translateX(10px);
	opacity: 0;
}

.topic-grpname {
	font-weight: 600;
	font-size: 14px;
	color: #1a4164;
}

.active-btn {
	width: 80px;
	background: #ccfacb;
	border-radius: 3px;
	padding: 5px;
}

.active-text {
	font-weight: 400;
	font-size: 12px;
	color: #038e00;
}

.inactive-btn {
	width: 80px;
	background: #ffeeee;
	padding: 5px;
	border-radius: 3px;
}

.inactive-text {
	font-weight: 400;
	font-size: 12px;
	line-height: 18px;
	color: #ad1927;
}

.topic-gt-tctxt {
	font-weight: 400;
	font-size: 13px;
	color: #696969;
}

.topic-gt-tccounttxt {
	font-weight: 500;
	font-size: 14px;
	color: #84a3fe;
}

.tcg-modal-grey {
	background: #f5f5f5;
}

.tcg-modal-head {
	font-weight: 400;
	font-size: 15px;
	color: #6d6d6d;
}

.tcg-modal-head-2 {
	font-weight: 400;
	font-size: 15px;
	color: #696969;
}

.tcg-modal-card {
	background: #ffffff;
	box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.2);
	border-radius: 10px;
	padding: 6px 8px 18px 12px;
}

.tcg-deactivate-box {
	background: #f4f4f4;
	border: 1px solid #eaeaea;
	border-radius: 2px;
}

.tcg-test-name {
	font-weight: 500;
	font-size: 14px;
	color: #696969;
}

.tcg-disable-text {
	font-weight: 500;
	font-size: 12px;
	color: #696969;
	padding: 4px 10px;
}

.tcg-active-text-red {
	font-weight: 500;
	font-size: 12px;
	color: #ffffff;
	background: #ad1927;
	border-radius: 3px;
	padding: 4px 10px;
}

.tcg-modal-overflow {
	min-height: auto;
	max-height: calc(100vh - 395px);
	overflow: auto;
}

.tcg-active-text-green {
	font-weight: 500;
	font-size: 12px;
	color: #ffffff;
	background: #038e00;
	border-radius: 3px;
	padding: 4px 10px;
}
.hidebutton.btn-secondary {
	background-color: #fff !important;
	color: black !important;
	border: none;
}
</style>
